import instance from '../API/api';

export const adminNotificationController = {
  async getList() {
    const { data } = await instance.get('notifications/admin/list');
    return data.data.map((item: any) => ({
      id: item.notification.id,
      title: item.notification.title,
      description: item.notification.description,
      createdAt: item.notification.createdAt,
      read: item.is_read,
      user: item.notification.user
        ? {
            first_name: item.notification.user.first_name,
            second_name: item.notification.user.second_name,
            id: item.notification.user.id,
            additionalData: item.notification.user.additionalData,
          }
        : '',
      company: item.notification.company
        ? {
            name: item.notification.company.name,
            id: item.notification.company.id,
          }
        : '',
    }));
  },

  async markAllAsRead() {
    await instance.put('notifications/admin/read-all');
  },

  async getUnreadCount() {
    const { data } = await instance.get('/notifications/admin/unread-count');
    return data.count;
  },

  async markAsRead(id: string) {
    return await instance.get(`/notifications/admin/find/${id}`);
  },
};
